import { OfferConfigureOperations, Operation } from '@occc-app/offerHelpers/types';
import type { FetchResult } from '@apollo/client';
import { useGetOfferOperationHandlers } from './useGetOfferOperationHandlers';

export type OperationResult = {
  name: OfferConfigureOperations;
  result: FetchResult<unknown>;
};

export async function runOperations(
  operations: Operation[],
  operationHandlers: ReturnType<typeof useGetOfferOperationHandlers>,
) {
  const operationResults: OperationResult[] = [];

  for (const operation of operations) {
    const handler = operationHandlers[operation.name];
    if (!handler) {
      throw new Error('Operation ' + operation.name + ' handler is not registered');
    }

    const result = await handler({
      variables: operation.variables,
    });

    operationResults.push({
      name: operation.name,
      result: result as FetchResult<unknown>,
    });
  }

  return operationResults;
}
